import { render, staticRenderFns } from "./shebeiPriceEdit.vue?vue&type=template&id=3304891c&scoped=true&"
import script from "./shebeiPriceEdit.vue?vue&type=script&lang=js&"
export * from "./shebeiPriceEdit.vue?vue&type=script&lang=js&"
import style0 from "./shebeiPriceEdit.vue?vue&type=style&index=0&id=3304891c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3304891c",
  null
  
)

export default component.exports